import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useNotifier } from '@provider/notifier';
import { useUserIdentityState } from '@provider/user-identity';
import { deleteTeamRequest } from './api.delete-team.request.js';
import { getTeamsQueryKey } from './api.get-teams.query.js';

function useDeleteTeamMutation() {
  const client = useQueryClient();
  const notifier = useNotifier();
  const user = useUserIdentityState(state => state.user);
  return useMutation(deleteTeamMutation(client, notifier, user));
}

/**
 * Deletes a team and removes it from the internal store collection
 * optimistically.
 */
const deleteTeamMutation = (client, notifier, user) => {
  return {
    mutationKey: ["user-area/teams/delete", user?.id],
    mutationFn: course => deleteTeamRequest(course),
    onMutate: async deleted => {
      await client.cancelQueries({
        queryKey: getTeamsQueryKey(user)
      });
      const data = client.getQueryData(getTeamsQueryKey(user));
      const deletedCourseIndex = data?.findIndex(it => it.id === deleted.id);
      client.setQueryData(getTeamsQueryKey(user), previous => previous?.filter(course => course.id !== deleted.id));
      return {
        deleted,
        index: deletedCourseIndex !== -1 ? deletedCourseIndex : undefined
      };
    },
    onSuccess: () => {
      notifier.notify({
        id: "user-area.teams.delete",
        type: "success",
        body: "Holdet er blevet slettet."
      });
    },
    onError: (error, _, context) => {
      notifier.notify({
        id: "user-area.teams.delete.error",
        type: "error",
        body: "Holdet kunne ikke slettes. Prøv igen om lidt."
      });
      client.setQueryData(getTeamsQueryKey(user), previous => {
        if (!context) {
          return previous;
        }
        const next = [...(previous ?? [])];
        if (context?.index) {
          next.splice(context.index, 0, context.deleted);
        } else {
          next.push(context.deleted);
        }
        return next;
      });
    }
  };
};

export { useDeleteTeamMutation };
//# sourceMappingURL=api.delete-team.mutation.js.map
